import * as z from "zod/v4";
import { returnsAnalyticsDataQualitySchema } from "./returns-analytics-shared";

export const getReturnsStuckHubspotDealsInputSchema = z.object({
  /** Deals untouched for at least this many days. Default 14. */
  stuckDaysThreshold: z.number().int().min(1).max(365).default(14),
  /** Max rows to return. Default 100. */
  limit: z.number().int().min(1).max(500).default(100),
});
export type GetReturnsStuckHubspotDealsInput = z.infer<
  typeof getReturnsStuckHubspotDealsInputSchema
>;

const stuckDealSchema = z.object({
  hubspotId: z.string(),
  dealName: z.string().nullable(),
  companyName: z.string().nullable(),
  stageNormalized: z.string(),
  stageLabel: z.string(),
  ownerId: z.string().nullable(),
  ownerName: z.string().nullable(),
  teamId: z.string().nullable(),
  amountCents: z.string(),
  daysSinceLastModified: z.number().int().min(0),
  daysSinceCreate: z.number().int().min(0),
  lastModifiedAt: z.date(),
  createdAt: z.date(),
});
export type ReturnsStuckHubspotDeal = z.infer<typeof stuckDealSchema>;

export const getReturnsStuckHubspotDealsOutputSchema = z.object({
  deals: z.array(stuckDealSchema),
  totalStuck: z.number().int().min(0),
  dataQuality: returnsAnalyticsDataQualitySchema,
});
export type GetReturnsStuckHubspotDealsOutput = z.infer<
  typeof getReturnsStuckHubspotDealsOutputSchema
>;

export const getReturnsStuckHubspotDeals = {
  name: "getReturnsStuckHubspotDeals" as const,
  input: getReturnsStuckHubspotDealsInputSchema,
  output: getReturnsStuckHubspotDealsOutputSchema,
};
